import ArchiveIndex from 'components/archive/ArchiveIndex';
import ArchiveMusicSubindex from 'components/archive/ArchiveMusicSubindex';
import RileylolMusicSubindex from 'components/archive/artist/rileylol/RileylolMusicSubindex';
import RileylolAllReleasesStatic from 'components/archive/artist/rileylol/music/RileylolAllReleasesStatic';
import { NavLink } from 'react-router-dom';

const ArchiveMusicRileylol = () => {
    return (
        <div class="main-column">
        
            <ArchiveIndex />
            
            <div class="card-container">
                <div class="title-wrap-rainbow2">
                <h2>Hellscape Digital - Music</h2>
                </div>
                <ArchiveMusicSubindex/>
            </div>

            <div class="card-container">
                <div class="sticky">
                <RileylolMusicSubindex/>
                <RileylolAllReleasesStatic/>
                </div>
            </div>

        </div>
    );
  };
  export default ArchiveMusicRileylol;